export const PAYMENT_GATEWAY_STATUS = {
  ENABLE: 1,
  DISABLE: 0, 
}

export const ENABLE_STATION_MESSAGE = {
  ENABLE: 1,
  DISABLE: 0,
}

export const STATION_TYPES = {
  MAIN_STATION: 1,
  SUB_STATION: 2,
}

export const PARTNER_STATION_TYPE_OPTIONS = [
  { value: 1, label: "Trung tâm đăng kiểm" },
  { value: 2, label: "Nội bộ TTDK" },
  { value: 3, label: "Garage" },
  { value: 4, label: "Cứu hộ" },
  { value: 5, label: "Đơn vị Bảo hiểm" },
  { value: 6, label: "Đơn vị tư vấn" },
  { value: 7, label: "Đơn vị liên kết" },
  { value: 8, label: "Đơn vị quảng cáo" },
  { value: 9, label: "Hợp tác xã" },
  { value: 10, label: "Đơn vị mua bán xe cũ" },
  { value: 11, label: "Đơn vị mua bán phụ tùng" },
  { value: 12, label: "Bãi giữ xe" },
  { value: 13, label: "Đơn vị cải tạo xe" },
  { value: 14, label: "Trường học lái xe" },
  { value: 15, label: "Dịch vụ lái xe hộ" },
  { value: 16, label: "Tư vấn sản xuất phụ tùng" },
  { value: 17, label: "Khám sức khoẻ lái xe" },
  { value: 18, label: "Showroom" },
  { value: 26, label: "Chăm sóc xe" },
  { value: 28, label: "Đại lý thuế" },
  { value: 29, label: "Phần mềm bán hàng" },
  { value: 30, label: "Chữ ký số" },
  { value: 31, label: "Hóa đơn điện tử" },
  { value: 32, label: "Bảo hiểm xã hội" },
  { value: 33, label: "Bảo hiểm y tế" },
  { value: 34, label: "Công ty kế toán" },
  { value: 35, label: "Bảo hiểm cháy nổ" },
];
